module.exports = __webpack_public_path__ + "img/menu-bars.7e105540.svg";